import {
  SET_PREFERENCES,
  // TODO: import action types added later
} from './types'

function setPreferences(basePreferences) {
  return {
    type: SET_PREFERENCES,
    payload: {
      basePreferences,
    },
  }
}
// TODO: add more action creators

export {
  // eslint-disable-next-line import/prefer-default-export
  setPreferences,
  // TODO: export action creators added later
}
